import { Note } from '@eigtech/notes-types'
import { Corn } from '@eigtech/shared-corn'
import { ContextualCan } from '@eigtech/ui-shared-auth'
import { Icon, IconButton, Tooltip, useDisclosure } from '@eigtech/ui-shared-dave'
import { MdGroupAdd as VisibilityIcon } from 'react-icons/md'
import { NoteVisibilityDrawer } from './NoteVisibilityDrawer/NoteVisibilityDrawer'

export type NoteVisibilityProps = {
  entityCorn: Corn
  note: Note
}

export function NoteVisibility({ entityCorn, note }: NoteVisibilityProps) {
  return (
    <ContextualCan I="update" a="note">
      <NoteUpdateVisibility {...{ entityCorn, note }} />
    </ContextualCan>
  )
}

function NoteUpdateVisibility({
  entityCorn,
  note,
}: Pick<NoteVisibilityProps, 'entityCorn' | 'note'>) {
  const noteVisibilityDrawer = useDisclosure()

  return (
    <>
      <Tooltip label="Update Note Visibility">
        <IconButton
          aria-label="Update Note Visibility"
          icon={<Icon as={VisibilityIcon} boxSize="6" />}
          isRound={false}
          size="sm"
          variant="outline"
          onClick={noteVisibilityDrawer.onOpen}
        />
      </Tooltip>

      {noteVisibilityDrawer.isOpen && (
        <NoteVisibilityDrawer {...noteVisibilityDrawer} entityCorn={entityCorn} note={note} />
      )}
    </>
  )
}
